import NotificationManagementEditComponent from './notification_management.edit.component';

let NotificationManagementEditModule = angular.module('notificationManagementEdit', [
])

.component('notificationManagementEdit', NotificationManagementEditComponent)

.name;

export default NotificationManagementEditModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/notification_management/edit/index.js